import { serviceDirectoryApiClient } from '@/services/service-directory';

export interface ServiceCategoryForm {
  categoryName: string;
  industry: string;
  description: string;
  order: number;
  icon: string;
}

class ServiceCategory {
  fetchServiceCategories = async (entityId?: string) => {
    const response = await serviceDirectoryApiClient.get('service-categories', {
      params: {
        entityId: entityId || '',
      },
    });
    return response.data;
  };

  fetchServiceCategory = async (id: string) => {
    const response = await serviceDirectoryApiClient.get(`service-categories/${id}`);
    return response.data;
  };

  createServiceCategory = async (serviceCategory: ServiceCategoryForm) => {
    const formData = this.formDataServiceCategory(serviceCategory);
    const response = await serviceDirectoryApiClient.post('service-categories', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  };

  updateServiceCategory = async (id: string, service: ServiceCategoryForm) => {
    const formData = this.formDataServiceCategory(service);
    const response = await serviceDirectoryApiClient.put(`service-categories/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  };

  deleteServiceCategory = async (id: string) => {
    const response = await serviceDirectoryApiClient.delete(`service-categories/${id}`);
    return response.data;
  };

  private formDataServiceCategory = (service: ServiceCategoryForm) => {
    const formData = new FormData();
    formData.append('categoryName', service.categoryName ?? '');
    formData.append('description', service.description ?? '');
    formData.append('icon', service.icon ?? '');
    formData.append('order', service.order.toString() ?? '');
    formData.append('industry', service.industry ?? '');
    return formData;
  };
}

export const ServiceCategoryInstance = new ServiceCategory();
